import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { RootState } from '../../app/store'
import { UserPlus, ShoppingBag } from 'lucide-react'

interface AddCustomerAlertModalProps {
  isOpen: boolean
  onClose: () => void
  onAddCustomer: () => void
  onChangeToTakeaway?: () => void
  /** When delivery, show customer+address message instead of customer+table */
  variant?: 'dine_in' | 'delivery'
}

const AddCustomerAlertModal: React.FC<AddCustomerAlertModalProps> = ({
  isOpen,
  onClose,
  onAddCustomer,
  onChangeToTakeaway,
  variant = 'dine_in'
}) => {
  const { t } = useTranslation()
  const isRTL = useSelector((state: RootState) => state.settings.settings.language === 'ar')

  if (!isOpen) return null

  const message =
    variant === 'delivery'
      ? (t('table.must_add_customer_and_address') ||
        'يجب إضافة العميل وعنوان التوصيل قبل إضافة المنتجات للسلة')
      : t('table.must_add_customer_and_table')

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/20 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className={`relative w-full max-w-md rounded-3xl bg-white shadow-[0px_24px_48px_rgba(18,18,23,0.08)] p-8 space-y-6 ${isRTL ? 'text-right' : 'text-left'}`}>
        <div className="flex flex-col items-center gap-2">
          <h3 className="text-2xl font-medium text-neutral-900 text-center font-['IBM Plex Sans Arabic']">
            {t('table.alert')}
          </h3>
          <p className="text-base text-black text-center leading-6 font-['IBM Plex Sans Arabic']">
            {message}
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <button
            onClick={onAddCustomer}
            className="w-full h-12 rounded-xl bg-flutter-button text-white font-semibold flex items-center justify-center gap-2 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.15)]"
          >
            <UserPlus className="h-4 w-4" />
            <span className="font-['IBM Plex Sans Arabic']">
              {t('customer.add_customer')}
            </span>
          </button>
          {onChangeToTakeaway && (
            <button
              onClick={onChangeToTakeaway}
              className="w-full h-12 rounded-xl border border-flutter-button bg-white text-flutter-button font-semibold flex items-center justify-center gap-2 font-['IBM Plex Sans Arabic']"
            >
              <ShoppingBag className="h-4 w-4" />
              <span>
                {t('order_type.takeaway')}
              </span>
            </button>
          )}
          <button
            onClick={onClose}
            className="h-12 rounded-xl border border-black bg-white text-black font-semibold flex items-center justify-center font-['IBM Plex Sans Arabic']"
          >
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AddCustomerAlertModal
